export default "__VITE_ASSET___l8xR5G3__"